import axios from "axios";

const getQuotationsByFilter = async (filter, company) => {
  try {
    // Quando "company" é informado, o backend consulta só aquela seguradora.
    // Isso permite buscar as 3 em paralelo e mostrar cada uma assim que chega.
    const result = await axios(`/api/quotations`, {
      params: {
        filter: company ? { ...filter, company } : filter,
      },
    });
    return result.data;
  } catch (error) {
    console.error(`Error fetching quotations: ${error}`);
    // Handle server errors gracefully
    if (error.response && error.response.status === 500) {
      console.error("Server error:", error.response.data);
    }
    // null (e não []) para quem chamou saber que a seguradora falhou.
    return null;
  }
};

export { getQuotationsByFilter };
